import React from 'react';
import { Box, Paper } from '@mui/material';
import { DefaultLayout } from '../../components/layout/default-layout';
import { useMetaTitle } from '../../hooks';
import { ServiceProviderUnitCalendar } from './service-provider-unit-calendar';
import { WithUserScopedServiceProviderUnitCheck } from './with-user-scoped-service-provider-unit-check';
import { TenantAddonConstants, useTenantAddons } from '../../components/tenant-addons';
import { CircularProgressCentered } from '../../components/circular-progress-centered';
import { PageNotFound } from '../../404';

function ServiceProviderUnitCalendarContent() {
  useMetaTitle('Kalender');

  return (
    <Box sx={{ px: 2, pt: 2 }}>
      <Paper elevation={0} sx={{ bgcolor: 'common.white', p: 2, borderRadius: 1 }}>
        <ServiceProviderUnitCalendar />
      </Paper>
    </Box>
  );
}

export function ServiceProviderUnitCalendarPage() {
  const { isTenantAddonEnabled, tenantAddons } = useTenantAddons();

  if (tenantAddons === undefined) {
    return <CircularProgressCentered />;
  }

  if (!isTenantAddonEnabled([TenantAddonConstants.JointCalendar])) {
    return <PageNotFound />;
  }

  return (
    <DefaultLayout>
      <WithUserScopedServiceProviderUnitCheck>
        <ServiceProviderUnitCalendarContent />
      </WithUserScopedServiceProviderUnitCheck>
    </DefaultLayout>
  );
}
